import { DataGetter } from '@rea-argonaut/analytics';
import { User } from '@property.com.au/argonaut';

interface UserData {
  user_login_status: 'logged_in' | 'not_logged_in';
  locke_id?: string | null;
  pcauid?: string | null;
  country_code?: string | null;
}

export const getPcaUserData =
  (user: User): DataGetter =>
  (): {
    user: {
      schema: `iglu:au.com.realestate/user/jsonschema/${string}`;
      data: UserData;
    };
  } => ({
    user: {
      schema: 'iglu:au.com.realestate/user/jsonschema/2-0-6',
      data: {
        user_login_status: user.isSignedIn ? 'logged_in' : 'not_logged_in',
        locke_id: user.isSignedIn && user.lockeId ? user.lockeId : null,
        pcauid: user.pcauid ?? null,
        country_code: user.countryCode ?? null,
      },
    },
  });
